import React, { FC } from 'react'

import BagsIcon from '@Assets/SVG/Categories/Bags'
import BeardCareIcon from '@Assets/SVG/Categories/BeardCare'
import BeltsIcon from '@Assets/SVG/Categories/Belts'
import BowTiesIcon from '@Assets/SVG/Categories/BowTies'
import BraceletsIcon from '@Assets/SVG/Categories/Bracelets'
import BracesIcon from '@Assets/SVG/Categories/Braces'
import CufflinksIcon from '@Assets/SVG/Categories/Cufflinks'
import EarringsIcon from '@Assets/SVG/Categories/Earrings'
import GlassesIcon from '@Assets/SVG/Categories/Glasses'
import GlovesIcon from '@Assets/SVG/Categories/Gloves'
import HatsIcon from '@Assets/SVG/Categories/Hats'
import LapelPinsIcon from '@Assets/SVG/Categories/LapelPins'
import NecklacesIcon from '@Assets/SVG/Categories/Necklaces'
import NecktiesIcon from '@Assets/SVG/Categories/Neckties'
import PocketSquaresIcon from '@Assets/SVG/Categories/PocketSquares'
import RingsIcon from '@Assets/SVG/Categories/Rings'
import ScarvesIcon from '@Assets/SVG/Categories/Scarves'
import ShavingIcon from '@Assets/SVG/Categories/Shaving'
import ShirtsIcon from '@Assets/SVG/Categories/Shirts'
import SunglassesIcon from '@Assets/SVG/Categories/Sunglasses'
import TieClipsIcon from '@Assets/SVG/Categories/TieClips'
import WalletsIcon from '@Assets/SVG/Categories/Wallets'
import WatchesIcon from '@Assets/SVG/Categories/Watches'
import { SVGIcon } from '@Components/Icons/SVGIcon'

const categoryIcons = {
  10: () => <SVGIcon icon={RingsIcon} />,
  11: () => <SVGIcon icon={EarringsIcon} />,
  112: () => <SVGIcon icon={ShavingIcon} />,
  13: () => <SVGIcon icon={NecktiesIcon} />,
  130: () => <SVGIcon icon={PocketSquaresIcon} />,
  135: () => <SVGIcon icon={HatsIcon} />,
  14: () => <SVGIcon icon={WatchesIcon} />,
  177: () => <SVGIcon icon={BeardCareIcon} />,
  195: () => <SVGIcon icon={LapelPinsIcon} />,
  201: () => <SVGIcon icon={BracesIcon} />,
  221: () => <SVGIcon icon={ScarvesIcon} />,
  223: () => <SVGIcon icon={ShirtsIcon} />,
  31: () => <SVGIcon icon={GlassesIcon} />,
  33: () => <SVGIcon icon={BeltsIcon} />,
  35: () => <SVGIcon icon={TieClipsIcon} />,
  36: () => <SVGIcon icon={CufflinksIcon} />,
  42: () => <SVGIcon icon={GlovesIcon} />,
  5: () => <SVGIcon icon={WalletsIcon} />,
  6: () => <SVGIcon icon={NecklacesIcon} />,
  63: () => <SVGIcon icon={BagsIcon} />,
  68: () => <SVGIcon icon={BowTiesIcon} />,
  7: () => <SVGIcon icon={BraceletsIcon} />,
  9: () => <SVGIcon icon={SunglassesIcon} />,
}

interface CategoryIconProps {
  categoryID: string
}

export const CategoryIcon: FC<CategoryIconProps> = (
  {
    categoryID,
  }: CategoryIconProps,
) => {
  if (!categoryIcons[categoryID]) {
    return null
  }

  return categoryIcons[categoryID]()
}
